import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  class: "inline-flex"
}
const _hoisted_2 = ["d"]
const _hoisted_3 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_4 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.type == 'outline')
    ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths, (path, index) => {
          return (_openBlock(), _createElementBlock("path", {
            key: index,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: path
          }, null, 8, _hoisted_2))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("svg", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths, (path, index) => {
          return (_openBlock(), _createElementBlock("path", {
            key: index,
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: path
          }, null, 8, _hoisted_4))
        }), 128))
      ]))
}